<div class="m-16">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <p>{{ data.message }}</p>
  </mat-dialog-content>
  <div>
    <mat-dialog-content>
      @for (field of data.formFields; track field) {
        <div>
          @if (field.type === 'input') {
            <mat-form-field [style]="field.style">
              <mat-label>{{ field.label }}</mat-label>
              <input matInput required="{{ field.required }}" [(ngModel)]="field.value" />
            </mat-form-field>
          }
          @if (field.type === 'date') {
            <mat-form-field [style]="field.style">
              <mat-label>{{ field.label }}</mat-label>
              <input
                matInput
                required="{{ field.required }}"
                [matDatepicker]="picker"
                [(ngModel)]="field.value"
                [placeholder]="'TT.MM.JJJJ'"
              />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          }
          @if (field.type === 'dropdown') {
            <mat-form-field [style]="field.style">
              <mat-label>{{ field.label }}</mat-label>
              <mat-select required="{{ field.required }}" [(value)]="field.value">
                @for (option of field.options; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (field.type === 'file') {
            <mat-form-field [style]="field.style">
              <mat-label>{{ field.label }}</mat-label>
              <input
                matInput
                readonly
                required="{{ field.required }}"
                [value]="getFileName(field)"
                (click)="fileInput.click()"
              />
              <input type="file" #fileInput hidden (change)="onFileSelected($event, field)" />
              <button mat-icon-button matIconSuffix type="button" (click)="fileInput.click()">
                <mat-icon>attach_file</mat-icon>
              </button>
            </mat-form-field>
          }
        </div>
      }
    </mat-dialog-content>
  </div>
  <mat-dialog-actions align="end">
    <su-button
      skin="warn"
      class="m-r-8"
      [label]="data.cancelButtonText || ('dialog.cancel' | translate)"
      (click)="onCancel()"
    >
    </su-button>
    <su-button
      skin="accept"
      [label]="data.okButtonText || ('dialog.ok' | translate)"
      (click)="onConfirm()"
      [disabled]="!allRequiredFieldsFilled()"
    >
    </su-button>
  </mat-dialog-actions>
</div>
